import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class StudentsActivityPortalStateService {
  private activeSectionSubject = new BehaviorSubject<string>('dean-message');
  activeSection$ = this.activeSectionSubject.asObservable();

  setActiveSection(id: string): void {
    this.activeSectionSubject.next(id);
  }
}